// extracted by mini-css-extract-plugin
export default {"notifySideButton":"NotifyUpdates_notifySideButton__gun4S","notifyActiveSideButton":"NotifyUpdates_notifyActiveSideButton__qyew3"};